module.exports = __webpack_public_path__ + "components/country-flag/static/ws-aa758751c1a198ec9ecbb6c266ef7d75.svg";